import {getMAWB, getHAWBs, getNext, getPrev, getBySerialNumber, getHAWBBySerialNumber } from '@/models/awb';
import JwtService from '@/services/jwt.service';



export default {
  async aInit({state, commit}, id) {
    try {
      state.loadingMAWB = true;
      state.loadingHAWB = true;
      commit('mSetDocumentId', id);
      commit('mReset', {});
      commit('mSetMAWB', null);
      commit('mSetHAWBs', []);
      try {
        
        let mawb = await getMAWB(id);
        commit('mSetMAWB', mawb);
      } catch(err) {

      }
      state.loadingMAWB = false;
      
      try {
        
        let hawbs = await getHAWBs(id);
        console.log("main hawb loaded", id);
        console.log("hawbs", hawbs);

        
        commit('mSetHAWBs', hawbs);
      } catch(err) {

      }
      state.loadingHAWB = false;
    } catch(err) {
      console.log('err', id);
    }
  },
  async loadAirports({commit}, data)  {

  },
  async loadMAWB({commit}, id)  {
    state.loadingMAWB = true;
    commit('mSetMAWB', null);
    try {
      let mawb = await getMAWB(id);
      commit('mSetMAWB', mawb);

    } catch(err) {

    }
    state.loadingMAWB = false;
  },
  async loadHAWBs({commit}, id)  {
    state.loadingHAWB = true;
    commit('mSetHAWBs', []);
    try {
      let hawbs = await getHAWBs(id);
      commit('mSetHAWBs', hawbs);
    } catch(err) {

    }
  
      state.loadingHAWB = false;
  },
  async aLoadPrev({commit}, id)  {

  },
  async aLoadPrev({commit}, id)  {
    let list = await getPrev(id);
    console.log("list", list);
  },
  async aLoadNext({commit}, id)  {
    let list = await getNext(id);
    console.log("list", list);
  },
  async aLoadBySerialNumber(context, serialNumber)  {
    // console.log("here");
    context.dispatch("aLoadMAWBBySerialNumber", serialNumber);
    context.dispatch("aLoadHAWBsBySerialNumber", serialNumber);
  },
  async aLoadMAWBBySerialNumber({commit}, serialNumber)  {
    commit('mSetMAWB', null);
    try {
      let mawb = await getBySerialNumber(serialNumber);
      if(mawb) {
        commit('mSetMAWB', mawb);
      }
      
    } catch(err) {
      // commit('mSetMAWB', null);
    }

  },
  async aLoadHAWBsBySerialNumber({commit}, serialNumber)  {
    commit('mSetMAWB', []);
    try {
      let hawbs = await getHAWBBySerialNumber(serialNumber);
      commit('mSetHAWBs', hawbs);
      console.log("list", list);
    } catch(err) {

    }
  }
};
